import './App.css';
import Wrapper from '../Wrapper/Wrapper';

function App() {
  return <Wrapper />;
}

export default App;
